module.exports = __webpack_public_path__ + "static/img/group_code.591d4e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/group_code.png
// module id = mQgS
// module chunks = 0